import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./BannerCard.module.css";
import Buttons from "../../components/buttons/Buttons";

function BannerCard({
  title,
  texts = [],
  banner,
  banner2,
  buttontext,
  navigateTo,
  type = 1,
  background = "white",
  bannerPosition = "center center", // 👈 add this
}) {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (navigateTo) navigate(navigateTo);
  };

  const renderTexts = () => {
    if (!texts) return null;

    // If single string
    if (typeof texts === "string") {
      return (
        <p className={`${styles.description} main_paragraph`}>
          {highlightDigitalNerve(texts)}
        </p>
      );
    }

    // If array of strings
    if (Array.isArray(texts)) {
      return texts.map((item, index) => (
        <p key={index} className={`${styles.description} main_paragraph`}>
          {highlightDigitalNerve(item)}
        </p>
      ));
    }

    return null;
  };

  const highlightDigitalNerve = (text) => {
    const target = "Digital Nerve";

    if (!text.includes(target)) return text;

    return text.split(target).map((part, index, array) =>
      index < array.length - 1 ? (
        <React.Fragment key={index}>
          {part}
          <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
            Digital Nerve
          </span>
        </React.Fragment>
      ) : (
        part
      ),
    );
  };

  return (
    <section
      className={styles.section}
      style={{
        backgroundColor: background === "grey" ? "#f5f5f5" : "#ffffff",
      }}
    >
      <div className={styles.bannerbody}>
        {/* 👉 TYPE 1 : IMAGE ➝ TEXT */}
        {type === 1 && (
          <>
            {" "}
            {banner && (
              <div className={`my-5 ${styles.banner}`}>
                <img
                  src={banner}
                  alt="Banner"
                  className={styles.bannerImage}
                  style={{ objectPosition: bannerPosition }}
                />
              </div>
            )}
            <div className={styles.content}>
              <h5 className={`main_heading ${styles.title}`}>{title}</h5>
              {renderTexts()}
              {banner2 && (
                <div className={`my-5 ${styles.banner2}`}>
                  <img
                    src={banner2}
                    alt="Banner"
                    className={styles.bannerImage2}
                  />
                </div>
              )}

              {buttontext && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "0.5rem",
                  }}
                >
                  <Buttons text={buttontext} onClick={handleNavigation} />
                </div>
              )}
            </div>
          </>
        )}

        {/* 👉 TYPE 2 : HEADING ➝ IMAGE ➝ TEXT */}
        {type === 2 && (
          <>
            <h5 className={`main_heading ${styles.title}`}>{title}</h5>
            {renderTexts()}
            {banner && (
              <div className={`${styles.banner}`}>
                <img
                  src={banner}
                  alt="Banner"
                  className={styles.bannerImage}
                  style={{ objectPosition: bannerPosition }}
                />
              </div>
            )}

            <div className={styles.content}>
              {banner2 && (
                <div className={`my-5 ${styles.banner2}`}>
                  <img
                    src={banner2}
                    alt="Banner"
                    className={styles.bannerImage2}
                  />
                </div>
              )}
              {buttontext && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "0.5rem",
                  }}
                >
                  <Buttons text={buttontext} onClick={handleNavigation} />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );
}

export default BannerCard;
